import {
    IntegrationAccount,
    IntegrationAccountBase,
} from "./integrationAccount";
import { User, UserBase } from "./user";
import type {
    StripeConnectionKind,
    StripeConnectionScope,
} from "./stripeConnection";

export enum ConnectionProviderType {
    STRIPE = "Stripe",
    GUSTO = "Gusto",
    PLAID = "Plaid",
    MERCURY = "Mercury",
    RAMP = "Ramp",
}

/**
 * Base type for FinancialConnection - allows undefined on relations.
 * Used by entity classes (TypeORM).
 */
export interface FinancialConnectionBase {
    id: number;
    connectionProvider: ConnectionProviderType;
    connectionExternalId: string;
    createdAt: Date;
    user?: UserBase | null;
    userId: number | null;
    accounts?: IntegrationAccountBase[];
    error: string | null;
    workspaceId?: string | null;
}

/**
 * Strict type for FinancialConnection - requires loaded relations.
 * Used by DTOs and service boundaries after relations are loaded.
 */
export interface FinancialConnection extends Omit<
    FinancialConnectionBase,
    "user" | "accounts"
> {
    user: User | null;
    accounts?: IntegrationAccount[];
    // Stripe-only readiness fields. Present on Stripe connections; the invoice
    // picker + accounts/integrations Incomplete helper key off `kind` +
    // `chargesEnabled`, never off `scope`.
    scope?: StripeConnectionScope;
    kind?: StripeConnectionKind;
    detailsSubmitted?: boolean;
    chargesEnabled?: boolean;
    isAbandoned?: boolean;
}

export interface FinancialConnectionWithAccounts extends FinancialConnection {
    accounts: IntegrationAccount[];
}
